"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var Cookies_1 = require("src/Cookies");
exports.IS_CANARY_USER_KEY = 'is-canary-user';
exports.ROWAN_TOKEN_COOKIE_NAME = 'rowan_client_token';
exports.AUTH_TOKEN_LS_KEY = 'authToken';
exports.GUEST_ID_KEY = 'guest-checkout-key';
exports.TWO_FACTOR_KEY = 'rowan_v_code';
var AuthToken = /** @class */ (function () {
    function AuthToken() {
        this.isCanaryUser = false;
        this.generateGuestUUID = function () { return "guest-" + uuid_1.v4(); };
        this.reload();
    }
    AuthToken.prototype.reload = function () {
        // load or generage guest uuid
        var guestUUID = Cookies_1.default.get(exports.GUEST_ID_KEY) ||
            this.generateGuestUUID();
        this.setGuestUUID(guestUUID);
        // load is canary user flag
        this.isCanaryUser = Boolean(Cookies_1.default.get(exports.IS_CANARY_USER_KEY));
        // load Authentication token
        var cookieToken = Cookies_1.default.get(exports.ROWAN_TOKEN_COOKIE_NAME);
        if (cookieToken) {
            this.setToken(cookieToken);
        }
        else {
            this.token = undefined;
        }
    };
    AuthToken.prototype.getToken = function () {
        return this.token;
    };
    AuthToken.prototype.getGuestUUID = function () {
        return this.guestUUID;
    };
    AuthToken.prototype.getIsCanaryUser = function () {
        return this.isCanaryUser;
    };
    AuthToken.prototype.clearTokens = function () {
        Cookies_1.default.remove(exports.ROWAN_TOKEN_COOKIE_NAME);
        Cookies_1.default.remove(exports.GUEST_ID_KEY);
        Cookies_1.default.remove(exports.IS_CANARY_USER_KEY);
        this.reload();
    };
    AuthToken.prototype.setToken = function (token) {
        this.token = token;
        var expireDate = new Date();
        expireDate.setMonth(expireDate.getMonth() + 12);
        Cookies_1.default.set(exports.ROWAN_TOKEN_COOKIE_NAME, token, expireDate);
    };
    AuthToken.prototype.updateCanaryUserCookie = function (isRowanUser, isCanary) {
        var wasCanary = this.isCanaryUser;
        if (isRowanUser === true || isCanary === true) {
            this.isCanaryUser = true;
            Cookies_1.default.set(exports.IS_CANARY_USER_KEY, 'yes');
        }
        else {
            this.isCanaryUser = false;
            Cookies_1.default.remove(exports.IS_CANARY_USER_KEY);
        }
        if (wasCanary !== this.isCanaryUser) {
            window.location.reload();
        }
    };
    AuthToken.prototype.setGuestUUID = function (guestUUID) {
        Cookies_1.default.set(exports.GUEST_ID_KEY, guestUUID);
        this.guestUUID = guestUUID;
    };
    return AuthToken;
}());
exports.default = new AuthToken();
